import { config } from '@xingternal/hops';
import { dispatchableFetch } from '@xingternal/hops-redux';

import {
  loadingEnd,
  loadingStart,
  updateConfig,
  submittingProcessingErrors,
} from '../state/actions';

const { apiBaseUrl } = config;

const fetchConfig = (queryParams) =>
  dispatchableFetch({
    url: `${apiBaseUrl}/contact/new${queryParams}`,
    headers: {
      'Content-Type': 'application/json',
    },
    onStart: loadingStart,
    onEnd: loadingEnd,
    onSuccess: updateConfig,
    onError: () => {
      return submittingProcessingErrors();
    },
  });

export default fetchConfig;
